import { useEffect, useState } from "react";

/** How long a figure may load before it says so (#2191 E14). */
export const SLOW_LOADING_MS = 3000;

/**
 * True once `isLoading` has stayed true for `SLOW_LOADING_MS`, false again the
 * moment the load ends: drives the "Still loading…" line under a skeleton, so
 * a slow figure reads as working rather than hung.
 */
export function useSlowLoading(isLoading: boolean): boolean {
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    if (!isLoading) return undefined;
    const timer = setTimeout(() => setSlow(true), SLOW_LOADING_MS);
    return () => {
      clearTimeout(timer);
      setSlow(false);
    };
  }, [isLoading]);
  return isLoading && slow;
}
